import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IAgreementChangeReasonInterface } from '../interfaces/IAgreementChangeReason';

export async function fetchAgreementChangeReason(): Promise<IAgreementChangeReasonInterface[]> {
  return apiGet<IAgreementChangeReasonInterface[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/change-reasons`,
  );
}
